<template>
  <div class="flex flex-col items-center justify-center py-12 px-4">
    <!-- Empty Cart Icon -->
    <div class="mb-4 text-4xl text-muted-foreground">
      <i class="fas fa-shopping-cart"></i>
    </div>

    <!-- Message -->
    <h3 class="mb-2 text-lg font-semibold text-foreground">
      Your Cart is Empty
    </h3>

    <!-- Subtext -->
    <p class="text-center text-sm text-muted-foreground">
      Add items from the shop to get started
    </p>
  </div>
</template>

<script setup lang="ts">
// Stateless component
</script>
